import { Component } from '@angular/core';
import { CustomDatePickerComponent } from '../../../shared-components/custom-date-picker/custom-date-picker.component';
import { TranslateService } from '../../../services/translate/translate.service';

@Component({
	selector: 'app-date-pickers',
	templateUrl: './date-pickers.component.html',
	styleUrls: ['./date-pickers.component.scss'],
	standalone: false,
})
export class DatePickersComponent {
	// Single date pickers
	singleBasic: string | null = null;
	singleFlatDate: string | null = null;
	singleFormat: string | null = null;
	singleEmitFormat: string | null = null;

	// Range date pickers
	rangeBasic: (string | null)[] | null = null;
	rangeFlatDate: (string | null)[] | null = null;
	rangeFormat: (string | null)[] | null = null;
	rangeEmitFormat: (string | null)[] | null = null;

	// Single date + time pickers
	singleTimeBasic: string | null = null;
	singleTimeFlatDate: string | null = null;
	singleTimeFormat: string | null = null;
	singleTimeEmitFormat: string | null = null;

	// Range date + time pickers
	rangeTimeBasic: (string | null)[] | null = null;
	rangeTimeFlatDate: (string | null)[] | null = null;
	rangeTimeFormat: (string | null)[] | null = null;
	rangeTimeEmitFormat: (string | null)[] | null = null;

	// Special pickers
	tooltipDate: string | null = null;
	requiredDate: string | null = null;
	validationValid = false;
	requiredDateRules: any[] = [];

	constructor(private translateService: TranslateService) {
		this.requiredDateRules = [CustomDatePickerComponent.createRules(this.translateService).required('This date field is required')];
	}

	onValidationChange(validation: { isValid: boolean; errors: string[] }): void {
		this.validationValid = validation.isValid;
	}
}
